export const menuItems = [
	{ id: 'home', label: '대시보드', icon: 'HomeIcon', href: '/dashboard' },
	{
		id: 'attendance',
		label: '출석 관리',
		icon: 'ClipboardCheckIcon',
		href: '/dashboard/attendance',
		alwaysExpanded: true,
		children: [
			{ id: 'check', label: '출석 체크', href: '/dashboard/attendance/check' },
			{ id: 'manage', label: '출석 내역', href: '/dashboard/attendance' }
		]
	},
	{ id: 'students', label: '학생 관리', icon: 'UsersIcon', href: '/dashboard/students' },
	{ id: 'courses', label: '수업 관리', icon: 'PresentationIcon', href: '/dashboard/courses' },
	{ id: 'makeups', label: '보강 관리', icon: 'RefreshIcon', href: '/dashboard/makeups' },
	{ id: 'placements', label: '입학테스트', icon: 'PencilIcon', href: '/dashboard/placements' },
	{
		id: 'schedule',
		label: '일정',
		icon: 'CalendarIcon',
		href: '/dashboard/schedule',
		alwaysExpanded: true,
		children: [
			{ id: 'monthly', label: '월간', href: '/dashboard/schedule/monthly' },
			{ id: 'yearly', label: '연간', href: '/dashboard/schedule/yearly' },
			{ id: 'holidays', label: '휴일', href: '/dashboard/schedule/holidays' }
		]
	},
	{ id: 'forms', label: '양식 관리', icon: 'DocumentIcon', href: '/dashboard/forms' },
	{ id: 'academy', label: '학원 관리', icon: 'BuildingIcon', href: '/dashboard/academy' },
	{
		id: 'settings',
		label: '설정',
		icon: 'CogIcon',
		href: '/dashboard/settings',
		children: [
			{ id: 'calendar', label: '달력', href: '/dashboard/settings/calendar' },
			{ id: 'profile', label: '프로필', href: '/dashboard/settings/profile' },
			{ id: 'delete-account', label: '회원 탈퇴', href: '/dashboard/settings/delete-account' }
		]
	},
	{ id: 'materials', label: '자료실', icon: 'FolderIcon', href: '/dashboard/materials' }
];
